import { useDebugOverrides } from '@/lib/debug/overrides'
import { BugIcon } from 'lucide-react'
import { useState } from 'react'
import { DebugModal } from './debug-modal'
import { ModeBannerPill } from './mode-banner'

const showTestingBanner = import.meta.env.VITE_SHOW_TESTING_BANNER === 'true'
const debugBarEnabled = import.meta.env.VITE_ENABLE_DEBUG_BAR === 'true'

export function TestingBanner() {
	const [isDebugOpen, setIsDebugOpen] = useState(false)
	const overrides = useDebugOverrides()
	const hasActiveOverride = Object.keys(overrides).length > 0

	if (!showTestingBanner) {
		return null
	}

	return (
		<>
			<ModeBannerPill
				label="Test Mode • Jobilla Staging"
				href="https://jobilla.slite.com/app/docs/xoSsjijvTxP3AV"
			>
				{debugBarEnabled && (
					<button
						type="button"
						onClick={() => setIsDebugOpen(true)}
						className={hasActiveOverride
							? 'cursor-pointer flex items-center justify-center px-2 border-l border-amber-400/60 bg-black text-amber-200 hover:bg-grey-800'
							: 'cursor-pointer flex items-center justify-center px-2 border-l border-amber-400/60 text-black/80 hover:bg-amber-300 hover:text-black'}
					>
						<BugIcon className="w-3.5 h-3.5" />
					</button>
				)}
			</ModeBannerPill>

			{debugBarEnabled && <DebugModal isOpen={isDebugOpen} onClose={() => setIsDebugOpen(false)} />}
		</>
	)
}
